import {Bot } from "lucide-react";

const TypingIndicator = ({ darkMode }) => (
  <div className="flex gap-3 mb-6">
    <div
      className={`w-10 h-10 rounded-full flex items-center justify-center ${
        darkMode ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-600"
      }`}
    >
      <Bot size={20} />
    </div>
    <div
      className={`${
        darkMode
          ? "bg-gray-800 text-gray-100 border border-gray-700"
          : "bg-white text-gray-700 shadow-md border border-gray-100"
      } rounded-2xl rounded-tl-md p-4`}
    >
      <div className="flex gap-1">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
        <div
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: "0.1s" }}
        />
        <div
          className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
          style={{ animationDelay: "0.2s" }}
        />
      </div>
    </div>
  </div>
);

export default TypingIndicator